import React, { type JSX } from 'react';
import {
  TableRow,
  TableCell,
} from '@core-ui/Components/ui/table';

interface Props {
  rows?: number;
}

export default function VoicemailTableSkeleton ({
  rows = 8,
}: Props): JSX.Element {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <TableRow key={i} className="border-b border-border">
          {/* Play button */}
          <TableCell className="py-3">
            <div className="h-9 w-9 rounded-full bg-muted animate-pulse" />
          </TableCell>

          {/* Name + date */}
          <TableCell className="py-3 min-w-[240px]">
            <div className="space-y-2">
              <div className="h-4 w-40 rounded bg-muted animate-pulse" />
              <div className="h-3 w-28 rounded bg-muted animate-pulse" />
            </div>
          </TableCell>

          {/* Waveform */}
          <TableCell className="py-3">
            <div className="h-6 w-full max-w-[320px] rounded bg-muted animate-pulse" />
          </TableCell>

          {/* Duration */}
          <TableCell className="py-3">
            <div className="h-4 w-14 rounded bg-muted animate-pulse" />
          </TableCell>

          {/* Actions */}
          <TableCell className="py-3 text-center">
            <div className="mx-auto flex justify-center gap-3">
              <div className="h-8 w-8 rounded bg-muted animate-pulse" />
              <div className="h-8 w-8 rounded bg-muted animate-pulse" />
            </div>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}
